import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'izy-loading-dialog',
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
  standalone: true,
  templateUrl: './loading-dialog.component.html',
  styleUrl: './loading-dialog.component.scss',
})
export class LoadingDialogComponent {
  constructor(public dialogRef: MatDialogRef<LoadingDialogComponent>) {
    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il contorno nero e l'angolo vivo non sono
       raggiungibili da uno stile incapsulato: servono le regole globali di
       .izy-loading-dialog-panel.
       La classe la aggiunge il componente e non il chiamante perche' i punti
       di apertura sono una dozzina sparsi per l'app e l'attesa ha sempre la
       stessa veste: cosi' resta scritta in un punto solo. */
    this.dialogRef.addPanelClass('izy-loading-dialog-panel');
  }
}
